import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, MapPin, Mail } from "lucide-react";
import { SOCIALS, GoogleIcon } from "./Socials";

const quick = [
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#portfolio" },
  { label: "Contact", href: "#contact" },
];
const services = ["Wedding Planning", "Decor & Design", "Catering", "Corporate Events", "Entertainment"];

export default function Footer() {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="site-footer" className="bg-heirloom-maroon-deep text-heirloom-bone/80">
      <div className="max-w-[1300px] mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <img src="/arihant-logo.jpeg" alt="Arihant Events" className="h-20 w-auto rounded-xl" />
          <p className="font-script text-2xl text-heirloom-gold-light mt-4">Your Imagination Is Our Creation</p>
          <p className="text-sm mt-3 leading-relaxed text-heirloom-bone/60">
            Crafting royal weddings, corporate galas and grand celebrations across India since 2011.
          </p>
          <div className="flex items-center gap-3 mt-5">
            <a href={SOCIALS.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="h-9 w-9 rounded-full bg-heirloom-bone/10 flex items-center justify-center hover:bg-heirloom-gold hover:text-heirloom-maroon-deep transition-colors">
              <Instagram size={16} />
            </a>
            <a href={SOCIALS.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="h-9 w-9 rounded-full bg-heirloom-bone/10 flex items-center justify-center hover:bg-heirloom-gold hover:text-heirloom-maroon-deep transition-colors">
              <Facebook size={16} />
            </a>
            <a href={SOCIALS.google} target="_blank" rel="noreferrer" data-testid="footer-google" aria-label="Google" className="h-9 w-9 rounded-full bg-white flex items-center justify-center hover:shadow-md transition-shadow">
              <GoogleIcon size={17} />
            </a>
          </div>
        </div>
        <div>
          <div className="font-display text-lg text-heirloom-bone mb-4">Quick Links</div>
          <ul className="space-y-2.5 text-sm">
            {quick.map((q) => <li key={q.label}><button onClick={() => go(q.href)} className="hover:text-heirloom-gold-light transition-colors">{q.label}</button></li>)}
          </ul>
        </div>
        <div>
          <div className="font-display text-lg text-heirloom-bone mb-4">Services</div>
          <ul className="space-y-2.5 text-sm">
            {services.map((s) => <li key={s} className="text-heirloom-bone/60">{s}</li>)}
          </ul>
        </div>
        <div>
          <div className="font-display text-lg text-heirloom-bone mb-4">Reach Us</div>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3"><MapPin size={16} className="text-heirloom-gold-light shrink-0 mt-0.5" /> Orbit Mall, Vijay Nagar, Indore, MP 452010</li>
            <li className="flex gap-3"><Phone size={16} className="text-heirloom-gold-light shrink-0 mt-0.5" /> <span>+91 87708 47087<br/>+91 93200 18909<br/>+91 80857 18909</span></li>
            <li className="flex gap-3"><Mail size={16} className="text-heirloom-gold-light shrink-0 mt-0.5" /> <a href="mailto:arihanteventsindore@gmail.com" className="hover:text-heirloom-gold-light transition-colors break-all">arihanteventsindore@gmail.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-heirloom-bone/10">
        <div className="max-w-[1300px] mx-auto px-6 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-heirloom-bone/50">
          <span>&copy; {new Date().getFullYear()} Arihant Event Management Services Pvt. Ltd.</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-heirloom-gold-light transition-colors">Admin Login</Link>
        </div>
      </div>
    </footer>
  );
}
